import Flickity from 'flickity';
import {players} from '../plugins/plyr';

class CarouselCaption {
	constructor(carousel) {
		this.DOM = {carousel};
		this.flkty = Flickity.data(carousel);
		this.initEvents();
	}
	initEvents() {
        this.flkty.on('select', (index) => {
            players.forEach((player) => player.plyr.pause());
        });
        this.flkty.resize();
	}
}

const carouselCaptionNodes = document.querySelectorAll('.carousel--has-caption');
[...carouselCaptionNodes].forEach((node) => new CarouselCaption(node));
